import './authCtrl';
import './userRegistrationCtrl';
import './changePassCtrl';
import './bikFormCtrl';


// WEBPACK FOOTER //
// src/js/controllers/user/index.js